._tourTooltipDefaultArrow_16i7v_1 {
  --size: 8px;
  --color: white;
  height: 0;
  width: 0; }

._top_16i7v_7 {
  border-bottom: var(--size) solid var(--color);
  border-left: var(--size) solid transparent;
  border-right: var(--size) solid transparent; }

._bottom_16i7v_12 {
  border-top: var(--size) solid var(--color);
  border-left: var(--size) solid transparent;
  border-right: var(--size) solid transparent; }

._left_16i7v_17 {
  border-right: var(--size) solid var(--color);
  border-top: var(--size) solid transparent;
  border-bottom: var(--size) solid transparent; }

._right_16i7v_22 {
  border-left: var(--size) solid var(--color);
  border-top: var(--size) solid transparent;
  border-bottom: var(--size) solid transparent; }
